import { render } from "./SurveyFreeText.vue?vue&type=template&id=4914582d&scoped=true"
import script from "./SurveyFreeText.vue?vue&type=script&lang=js"
export * from "./SurveyFreeText.vue?vue&type=script&lang=js"

import "./SurveyFreeText.vue?vue&type=style&index=0&id=4914582d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4914582d"]])

export default __exports__